// The CSP nonce reaches style-injecting code before any other module runs (ADR 0016): keep this first.
import './app/csp-nonce.ts';
// The read cache is the page's fetch before any API client is made (Board #2594): keep this second.
import { browserFetch, setNetworkFetch } from './modules/platform/index.ts';
import { ConfirmProvider, Toaster } from '@cortex/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './app/ports.tsx';
import { createRouter } from './app/router.tsx';
import './index.css';
import { AuthProvider } from './modules/identity/index.ts';
import { BadgesProvider } from './modules/identity/index.ts';
import { queryClient } from './modules/platform/index.ts';
import { ThemeProvider } from './modules/platform/index.ts';
import { apiBaseUrl, getAccessToken } from './modules/platform/index.ts';
import { reportUncaughtErrors } from './modules/platform/index.ts';
import { browserTracingOn } from './modules/platform/index.ts';

reportUncaughtErrors();

const router = createRouter();

// Browser tracing (dev only: the web server writes the meta): the SDK is a lazy chunk, absent otherwise.
if (browserTracingOn())
  void import('./modules/platform/index.ts')
    .then((door) => door.pages['tracing/browser-tracing']())
    .then((m) =>
      m.startBrowserTracing({
        router,
        apiBase: apiBaseUrl,
        browserFetch,
        setNetworkFetch,
        getToken: getAccessToken,
      }),
    )
    .catch(() => {});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <BadgesProvider>
            <ConfirmProvider>
              <RouterProvider router={router} />
              <Toaster />
            </ConfirmProvider>
          </BadgesProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
